import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { string } from 'prop-types';
import { background } from '../../constants/LOADER';

interface State {
  waitingForSubscription: boolean;
  bankSlipURL: string;
  bankSlipCode: string;
  bankSlipDueDate: string;
  showBankSlipModal: boolean;
  discount: number;
  disableButton: boolean;
  isLoading: boolean;
  backgroundType: string;
}

const initialState: State = {
  waitingForSubscription: false,
  bankSlipURL: null,
  bankSlipCode: null,
  bankSlipDueDate: null,
  showBankSlipModal: false,
  discount: null,
  disableButton: false,
  isLoading: true,
  backgroundType: background.SOLID,
};

const subscription = createSlice({
  name: 'subscription',

  initialState,

  reducers: {
    updateSubscriptionResponse(state, action: PayloadAction<any>) {
      state.waitingForSubscription = action.payload.waitingForSubscription;
      state.bankSlipURL = action.payload.bankSlipURL;
      state.bankSlipCode = action.payload.bankSlipCode;
      state.bankSlipDueDate = action.payload.bankSlipDueDate;
      state.showBankSlipModal = action.payload.showBankSlipModal;
      state.discount = action.payload.discount;
    },

    isSubscribing(state, action: PayloadAction<boolean>) {
      state.disableButton = action.payload;
      state.isLoading = action.payload;
      state.backgroundType = background.TRANSPARENT;
    },

    isLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    isLoadingTransparent(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
      state.backgroundType = background.TRANSPARENT;
    },
  },
});

export const {
  updateSubscriptionResponse,
  isSubscribing,
  isLoading,
  isLoadingTransparent,
} = subscription.actions;

export default subscription.reducer;
